<template lang="pug">
  .stock-info.cc-stock-info
    .available-for-period(v-if="availableForPeriod !== undefined")
      | Доступно {{availableForPeriod}} шт.
    div(v-else)
      .current-stock.cc-current-stock(v-if="currentStock > 0")
        | На складе {{currentStock}} шт.
      .upcoming-batches.cc-upcoming-batches(v-if="displayBatches.length > 0")
        .batch-item.cc-batch-item(v-for="batch in displayBatches" :key="batch.id")
          .fixed-batch.cc-fixed-batch(v-if="!batch.is_moving")
            | К {{batch.will_arrive_on | formatDate}} {{currentStock > 0 ? 'еще ' : '' }}{{batch.quantity}} шт.
          .moving-batch.cc-moving-batch(v-if="batch.is_moving")
            | Под заказ ({{batch.orderDays | decline(['день', 'дня', 'дней'])}}) {{batch.quantity === 1 ? '' : 'до '}}{{batch.quantity}} шт.
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

export default {
  name: 'stock-info',
  props: {
    availableForPeriod: {
      type: Number
    },
    currentStock: {
      type: Number,
      required: true
    },
    batches: {
      type: Array,
      default: () => []
    },
    article: {
      type: Object,
      default: null
    },
  },
  computed: {
    firstMovingBatch() {
      // Возвращаем объект первой движущейся партии с вычисленным orderDays
      const movingBatch = this.movingBatches[0]
      if (!movingBatch) {
        return null // Нет движущихся партий
      }
      
      const today = dayjs().startOf('day')
      const arrivalDate = dayjs(movingBatch.will_arrive_on).startOf('day')
      const daysUntilArrival = arrivalDate.diff(today, 'day')
      const orderDays = Math.max(1, daysUntilArrival)
      
      return {
        ...movingBatch,
        orderDays
      }
    },
    fixedBatches() {
      return this.batches
        .filter(batch => !batch.is_moving)
        .sort((a, b) => new Date(a.will_arrive_on) - new Date(b.will_arrive_on))
    },
    movingBatches() {
      return this.batches.filter(batch => batch.is_moving)
    },
    displayBatches() {
      const batches = []
      
      // Добавить только первую фиксированную партию (самую раннюю по дате)
      if (this.fixedBatches.length > 0) {
        batches.push(this.fixedBatches[0])
      }
      
      // Добавить первую движущуюся партию с вычисленным orderDays
      if (this.firstMovingBatch) {
        batches.push(this.firstMovingBatch)
      }
      
      return batches
    },
    calculateSetStockQuantity() {
      // Вычисляем количество набора на основе минимального количества компонентов
      if (!this.article?.components_with_quantity || this.article.components_with_quantity.length === 0) {
        return 0
      }
      
      let minAvailable = Infinity
      
      for (const component of this.article.components_with_quantity) {
        const componentStockQuantity = component.stock_quantity || 0
        const requiredQuantity = component.quantity || 1
        const availableSets = Math.floor(componentStockQuantity / requiredQuantity)
        
        minAvailable = Math.min(minAvailable, availableSets)
      }
      
      return minAvailable === Infinity ? 0 : minAvailable
    }
  },
  filters: {
    formatDate(dateString) {
      return dayjs(dateString).format('D MMMM')
    }
  }
}
</script>

<style scoped>
.stock-info {
  font-size: 12px;
  color: #2b2b2b;
  line-height: 18px;
}

.current-stock {
  margin-bottom: 2px;
}

.upcoming-batches {
  margin-bottom: 4px;
}

.batch-item {
  margin-bottom: 1px;
}

.batch-labels {
  margin-top: 4px;
}
</style>